import { render, staticRenderFns } from "./AddMessagePartButton.vue?vue&type=template&id=0894f760&scoped=true"
import script from "./AddMessagePartButton.vue?vue&type=script&lang=ts"
export * from "./AddMessagePartButton.vue?vue&type=script&lang=ts"
import style0 from "./AddMessagePartButton.vue?vue&type=style&index=0&id=0894f760&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0894f760",
  null
  
)

export default component.exports